// will be set by webpack
declare const __VERSION__: string
declare const __VERSION_PREFIX__: string

export const VERSION = __VERSION__
export const VERSION_PREFIX = __VERSION_PREFIX__
